import { Modal as NBModal, ScrollView, Text, View } from "native-base";
import { IModalProps } from "native-base/lib/typescript/components/composites/Modal/types";
import React from "react";
import RNModal from "react-native-modal";

import { useViewport } from "@/contexts/ViewportContext";

type ModalProps = {
  Header: string | React.ReactElement;
  Body: React.ReactElement;
  Footer?: React.ReactElement;
} & Pick<IModalProps, "isOpen" | "onClose">;

const Modal = ({ Footer, Header, Body, isOpen, onClose }: ModalProps) => {
  const { isWebMode } = useViewport();
  const style = isWebMode ? { marginHorizontal: "20%" } : { margin: 0, justifyContent: "flex-end" };

  return (
    <RNModal
      isVisible={isOpen}
      onDismiss={onClose}
      useNativeDriver
      avoidKeyboard
      animationIn={isWebMode ? "fadeIn" : "slideInUp"}
      animationOut={isWebMode ? "fadeOut" : "slideOutDown"}
      style={style as any}>
      <View bgColor="white.50" maxH="90%" roundedTop="lg">
        <NBModal.CloseButton onPress={onClose} />
        <NBModal.Header roundedTop="lg" bgColor="white.50">
          <Text fontSize="xl" maxW="95%" bold>
            {Header}
          </Text>
        </NBModal.Header>
        <ScrollView flexGrow={0} p="4" bgColor="white.50">
          {Body}
        </ScrollView>
        {!!Footer && <NBModal.Footer bgColor="white.50">{Footer}</NBModal.Footer>}
      </View>
    </RNModal>
  );
};

export default Modal;
